export default __webpack_public_path__ + "static/media/ic-sort-down.c412cef4.svg";